module.exports = __webpack_public_path__ + "img/test.72fe8294.jpg";